// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * RecordMap category — enum, not string. 1 byte.
 */
export enum RecordMapCategory {
  Position = 0,
  Service = 1,
  Bitmask = 2,
}
